import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "swiper/swiper-bundle.css";
import "@/assets/scss/base.scss";
import { VueQueryPlugin } from '@tanstack/vue-query'
import { getAxios } from './lib/AxiosCall'
import { getConfig, setConfig, getConfigDate, getToday } from './lib/Config'
import { siteHostname, currentSiteUrl } from './lib/Seo'
import SiteIntro from './components/SiteIntro.vue'
import BrandSeoSummary from './components/BrandSeoSummary.vue'

// 전역 상태 관리
let isConfigLoading = false;
let configLoadedToday = false;

const NH_PRM_HOSTNAME = "nhprm.hivitamin.co.kr";
const NH_PRM_BRANCH_UUID = "84372c6d-b180-4dbd-b2c9-1a0cf7535f76";

const applyHostBranchUuid = (config) => {
    if (siteHostname() !== NH_PRM_HOSTNAME) {
        return config;
    }

    const updatedConfig = {
        ...(config || {}),
        branch: {
            ...(config?.branch || {}),
            branchUuid: NH_PRM_BRANCH_UUID,
        },
    };
    setConfig(updatedConfig);
    sessionStorage.setItem("branchUuid", NH_PRM_BRANCH_UUID);
    return updatedConfig;
};

applyHostBranchUuid(getConfig());

const app = createApp(App)

app.use(VueQueryPlugin)
app.use(router)
app.component('SiteIntro', SiteIntro)
app.component('BrandSeoSummary', BrandSeoSummary)

// 최초 페이지 로드(SEO 직접 접근 포함) 시에도 SPA 환경에서 page_view를 전송
// 이유: 직접 진입(서버에서 렌더된 index.html로 접근) 시에는 브라우저가 새로 로드되므로
// GTM 스니펫은 동작하지만 SPA 내부 라우트와 동일한 형태의 page_view 이벤트를
// 일관되게 수집하려면 초기 마운트 시 명시적 전송이 필요합니다.
function _sendInitialPageView() {
    try {
        const page_path = (router && router.currentRoute && router.currentRoute.value && router.currentRoute.value.fullPath) || (window.location.pathname + window.location.search);
        const page_title = document.title || '';
        const page_location = (typeof window !== 'undefined' && window.location && window.location.href) ? window.location.href : '';

        if (typeof window !== 'undefined' && Array.isArray(window.dataLayer)) {
            window.dataLayer.push({
                event: 'page_view',
                page_path,
                page_title,
                page_location,
                page_host: (window.location && window.location.hostname) || '',
            });
        }

        if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
            window.gtag('event', 'page_view', { page_path, page_title, page_location, page_host: (window.location && window.location.hostname) || '' });
        }
    } catch (e) {
        // no-op: analytics push should not break app
    }
}

// router가 준비된 뒤 초기 page_view 전송 (SEO 직접 진입 포함)
if (router && typeof router.isReady === 'function') {
    router.isReady().then(() => _sendInitialPageView()).catch(() => {});
} else {
    // fallback
    _sendInitialPageView();
}

// 준비중 알림 및 창 닫기 함수
function showPrepareAlertAndClose() {
    alert("준비중인 사이트입니다.");
    console.log('준비중 알림 확인 - 창 닫기 시도');
    if (window.opener) {
        window.close();
    } else {
        try {
            console.log('창 닫기 실패, 빈 페이지로 이동');
            window.location.href = 'about:blank';
        } catch (e) {
            console.log('창 닫기 실패, 빈 페이지로 이동');
            window.location.href = 'about:blank';
        }
    }
}

app.mixin({
    beforeCreate() {
        const configDate = getConfigDate();
        const today = getToday();
        let config = getConfig();

        
        const currentUrl = currentSiteUrl();
        // config 1일 1회만 로드
        if (isConfigLoading) {
            return;
        }

        const isNhPrmHost = siteHostname() === NH_PRM_HOSTNAME;
        if (config && configDate && configDate === today && !isNhPrmHost) {
            // 이미 오늘 config가 있으니 여기서 종료
            return;
        }

        // 최초 1회만 config API 호출
        isConfigLoading = true;

        const apiParams = { siteUrl: currentUrl };

        getAxios("/hvm/v1/common/config", apiParams)
            .then((res) => {
                if (res.config && res.config.branch && res.config.branch.branchSttsType !== "BRANCH_STTS_ING") {
                    //showPrepareAlertAndClose();
                    return;
                } else {
                    setConfig(applyHostBranchUuid(res.config));
                }
            })
            .catch(error => {
                console.error('Config API 호출 에러:', error);
                //showPrepareAlertAndClose();
            })
            .finally(() => {
                isConfigLoading = false;
            });
    }
})

app.mount('#app')

